/* unplugin-vue-components disabled */import { render } from "./shipments_detail.vue?vue&type=template&id=4d5c94a4&scoped=true"
import script from "./shipments_detail.vue?vue&type=script&lang=js"
export * from "./shipments_detail.vue?vue&type=script&lang=js"

import "./shipments_detail.vue?vue&type=style&index=0&id=4d5c94a4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5c94a4"]])

export default __exports__